export default {
  path: '/meter-models/:id',
  component: () => import('@/components/pages/MeterModels/MeterModel.vue')
}
